export default "__VITE_ASSET__CknTd5eA__"